<template>
	<div class="container">
		<div class="header">
			<img class="bg" src="../../assets/home/top_bg_2.png" alt="" />
			<div class="header-con">
				<div class="top col-center">
					<div class="logo">
						<img src="../../assets/home/logo_2.png" alt="" />
					</div>
					<div class="title">
						<div class="main">高等学校教学实验室数据管理平台</div>
						<div class="sub">Data Management Platform for Teaching Laboratories in Higher Education
							Institutions</div>
					</div>
				</div>
				<div class="info flex">
					<div class="left">
						<div class="rubric flex">
							<div class="text">工作动态</div>
						</div>
						<div class="list-group">
							<div class="item col-center flex-sb" @click="jump(item.href)" v-for="(item,index) in list"
								:key="">
								<div class="text">{{item.text}}</div>
								<div class="date">{{item.date}}</div>
							</div>
						</div>
					</div>
					<div class="right">
						<div class="rubric flex">
							<div class="text">管理平台</div>
						</div>
						<div class="case-group">
							<div class="item" @click="jump(item.href,item.msg || '')" v-for="(item,index) in caseList" :key="index">
								<img :src="item.img" alt="" />
								<div class="float" :class="{small:item.isSmall,'animate__animated':index === 0,'animate__heartBeat':index === 0}">
									{{item.text}}
								</div>
								<div class="arrow col-center">
									<div><img src="../../assets/home/arrow.png" alt="" /></div>
									<div>点击进入</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer>
			<div class="con">
				<div class="item">咨询时间：星期一至星期五 早08:00 - 晚17:00</div>
				<!-- <div class="item">技术咨询QQ群：630112305（1群已满）、658056194（2群）</div> -->
				<div class="item">版权所有 © 2024 高等学校教学实验室数据管理平台 | <a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff;text-decoration: none;">沪ICP备2021028823号</a> | 联系我们:19524511118(微信) 15045096087(微信)
				</div>
			</div>
		</footer>
	</div>
</template>

<script>
	export default {
		name: '',
		props: {

		},
		components: {

		},
		data() {
			return {
				list: [{
					text: '【教育部】教育部高等教育司关于公布实验教学和教学实验室建设研究项目立项名单的通知',
					date: '2024年06月26日',
					href: 'http://www.moe.gov.cn/s78/A08/tongzhi/202406/t20240627_1138089.html'
				}, {
					text: "【教育部】教育部高等教育司关于开展实验教学和教学实验室建设研究工作的通知",
					date: "2024年02月04日",
					href: 'http://www.moe.gov.cn/s78/A08/tongzhi/202402/t20240204_1114381.html'
				}, {
					text: "【央广国际】国家级实验教学示范中心总结推进会召开",
					date: "2024年01月18日",
					href: 'https://jx.cri.cn/2024-01-18/39bcec93-be4f-14c3-b6b0-18cc7876f10d.html'
				}, {
					text: "【学习强国】教育部：完善实验教学体系 培养拔尖创新人才",
					date: "2024年01月17日",
					href: 'https://article.xuexi.cn/articles/index.html?art_id=14286607188443342288&source=share&study_style_id=video_default&reco_id=1027e6025f44c0a82217000c&share_to=wx_single&study_share_enable=1&study_comment_disable=0&ptype=0&item_id=14286607188443342288'
				}, {
					text: "【学习强国】实验教学智慧化转型 帮助学生在真问题中练就真本领",
					date: "2024年01月17日",
					href: 'https://article.xuexi.cn/articles/index.html?art_id=7862216394964463681&source=share&study_style_id=video_default&reco_id=1027e6025f44c0a82217000c&share_to=wx_single&study_share_enable=1&study_comment_disable=0&ptype=0&item_id=7862216394964463681'
				}, {
					text: "【学习强国】记者探访国家级实验教学示范中心",
					date: "2024年01月17日",
					href: 'https://article.xuexi.cn/articles/index.html?art_id=5512105999528210626&source=share&study_style_id=video_default&reco_id=1027e6025f44c0a82217000c&share_to=wx_single&study_share_enable=1&study_comment_disable=0&ptype=0&item_id=5512105999528210626'
				}, {
					text: "【学习强国】以一流实验教学支撑拔尖创新人才培养——国家级实验教学示范中心总结推进会举行",
					date: "2024年01月17日",
					href: 'https://article.xuexi.cn/articles/index.html?art_id=1418222142307185277&source=share&study_style_id=feeds_default&reco_id=1027e6055a51c0a8847a0012&share_to=wx_single&study_share_enable=1&study_comment_disable=0&ptype=0&item_id=1418222142307185277'
				}, {
					text: "【教育部】国家级实验教学示范中心总结推进会成功举行",
					date: "2024年01月17日",
					href: 'http://wap.moe.gov.cn/jyb_xwfb/gzdt_gzdt/s5987/202401/t20240117_1100722.html'
				}, {
					text: "【央视新闻】如何上好大学实验课记者探访国家级实验教学示范中心",
					date: "2024年01月17日",
					href: 'https://content-static.cctvnews.cctv.com/snow-book/video.html?item_id=13603854425154830266&t=1705458621769&toc_style_id=video_default&share_to=wechat&track_id=d818bed0-7b54-44f7-8d2e-78acee8b07c6'
				}, {
					text: "【央视新闻】如何上好大学实验课 在真问题中练就真本领",
					date: "2024年01月17日",
					href: 'https://content-static.cctvnews.cctv.com/snow-book/video.html?item_id=14069770582957407761&t=1705458745999&toc_style_id=video_default&share_to=wechat&track_id=6928b42f-00a5-4f6f-8f88-e3151b761c6d'
				}, {
					text: "【央视新闻】如何上好大学实验课·教育部 完善实验教学体系 培养拔尖创新人才",
					date: "2024年01月17日",
					href: 'https://content-static.cctvnews.cctv.com/snow-book/video.html?item_id=14249297022659577703&t=1705458998095&toc_style_id=video_default&share_to=wechat&track_id=f1bcef99-2c6f-40db-8c3a-f0c58845fa31'
				}, {
					text: "【中国教育报】以一流实验教学支撑拔尖创新人才培养——国家级实验教学示范中心总结推进会举行",
					date: "2024年01月17日",
					href: 'http://newapp.jyb.cn/app_pub/zixun/gaojiao/all/202401/t20240117_112900.html?docId=112900'
				}],
				caseList: [{
					text: '高校教学实验室安全工作年度报告管理系统',
					img: require('../../assets/home/box04.png'),
					href: 'http://122.51.76.10:8090/'
				}, {
					text: '实验教学和教学实验室建设研究项目管理系统',
					img: require('../../assets/home/box01.png'),
					href: 'http://122.51.76.10:8080'
				},{
					text: '国家级实验教学示范中心年度报告管理系统',
					img: require('../../assets/home/box01.png'),
					// href: 'http://122.51.76.10:8802/'
					isSmall: true,
					msg:'暂未开通'
				}, {
					text: '国家级实验教学示范中心阶段性总结工作管理系统',
					img: require('../../assets/home/box02.png'),
					// href: 'http://1.92.133.4/newSFZX/',
					isSmall: true,
				}, {
					text: '国家级虚拟仿真实验教学中心年度报告管理系统',
					img: require('../../assets/home/box03.png'),
					// href: 'http://1.92.133.4/sfzxold/',
					isSmall: true,
				}]
			}
		},
		created() {},
		mounted() {

		},
		methods: {
			jump(href,text) {
				if(href){
					window.open(href)
				}else{
					const h = this.$createElement;
					this.$alert(text || '非填报工作时间，系统关闭，请联系管理员！', '提示', {
						confirmButtonText: '确定',
						message: h('p', null, [
							h('div', {
								style: 'color: #000;font-size:18px;'
							}, text || '非填报工作时间，系统关闭，请联系管理员')
						]),
						callback: action => {
					
						}
					});
				}
				
			}
		}

	}
</script>

<style lang="scss" scoped>
	@import '../../assets/css/animate.min.css';
	.container {
		.header {
			display: flex;
			position: relative;
			justify-content: center;

			img {
				width: 100%;
			}
			img.bg{
				position: absolute;
				top: 0;
			}
			.header-con {
				position: relative;
				z-index: 2;
				width: 1320px;
				padding-bottom: 20px;
				.top {
					padding: 50px 0;

					.logo {
						width: 64px;
						height: 64px;
					}

					.title {
						padding-left: 20px;

						.main {
							text-shadow: 0px 3px 0px rgba(73, 122, 194, 0.5);
							// background: linear-gradient(0deg, #BBD7FF 0%, #FFFFFF 100%);
							font-weight: 800;
							font-size: 38px;
							color: #F6FAFF;
						}

						.sub {
							color: #C9E1FF;
							font-size: 15px;
						}
					}
				}

				.info {
					background-color: white;
					padding: 0 25px;

					.left {
						flex-grow: 1;
						width: 0;
						padding-right: 30px;

						.list-group {
							padding: 10px 0;

							.item {
								padding: 11px 0;
								cursor: pointer;

								.text {
									font-size: 18px;
									width: 0;
									flex-grow: 1;
									text-overflow: ellipsis;
									overflow: hidden;
									white-space: nowrap;
								}

								.date {
									font-size: 16px;
									flex-shrink: 0;
									padding-left: 20px;
									color: #8E8E8E;
								}
							}

							.item:hover {
								.text {
									color: #4389e0;
									font-weight: bold;
								}

								.date {
									font-weight: bold;
									color: #8E8E8E;
								}
							}
						}
					}

					.right {
						width: 520px;

						.case-group {
							padding: 10px 0;

							.item {
								cursor: pointer;
								// padding: 10px 0;
								position: relative;
								display: flex;
								justify-content: center;
								align-items: center;
								align-content: center;

								img {
									height: 110px;
								}

								.float {
									position: absolute;
									z-index: 2;
									font-size: 22px;
									color: #FFFFFF;
									font-weight: bold;
									margin-top: -10px;
									text-shadow: 0px 3px 0px rgba(58, 121, 174, 0.5);
									animation-iteration-count:infinite;
								}

								.arrow {
									position: absolute;
									z-index: 3;
									bottom: 20px;
									right: 40px;
									color: white;
									font-size: 14px;
									height: 14px;
									line-height: 14px;

									img {
										width: 48px;
										height: 14px;
										margin-right: 10px;
										margin-bottom: -2px;
									}
								}
							}
						}
					}

					.rubric {
						border-bottom: 2px solid #ABCCE9;

						.text {
							font-weight: bold;
							font-size: 26px;
							color: #4389E0;
							padding: 16px 0;
							border-bottom: 4px solid #4389E0;
							margin-bottom: -2px;
							padding-right: 10px;
						}
					}
				}
			}
		}

		footer {
			display: flex;
			justify-content: center;
			background-color: #115EA2;
			position: relative;
			z-index: 2;
			.con {
				width: 1320px;
				padding: 10px 0;

				.item {
					color: white;
					text-align: center;
					padding: 6px;
				}
			}
		}
	}

	@media screen and (max-width: 922px) {
		.container {
			.header {
				display: flex;
				position: sticky;
				justify-content: center;
				position: relative;

				img.bg {
					position: absolute;
					height: 100%;
				}

				.header-con {
					position: sticky;
					width: 100%;

					.top {
						padding: 20px;
						display: flex;
						justify-content: center;

						.logo {
							width: 32px;
							height: 32px;
						}

						.title {
							padding-left: 5px;

							.main {
								font-size: 20px;

							}

							.sub {
								display: none;
							}
						}
					}

					.info {
						margin:0 10px;
						// width: 100%;
						box-sizing: border-box;
						flex-wrap: wrap;
						padding: 10px;

						.left {
							width: 100%;
							padding-right: 0;
							order: 2;
							.list-group {
								padding: 4px 0;

								.item {
									padding: 4px 0;
									cursor: pointer;

									.text {
										font-size: 12px;
									}

									.date {
										font-size: 10px;
										padding-left: 10px;
									}
								}
							}
						}

						.right {
							width: 100%;
							order: 1;
							.case-group {
								padding: 10px 0;

								.item {
									.float {
										font-size: 16px;
										margin-top: -18px;
									}

									.float.small {
										font-size: 15px;
									}

									img {
										height: 100px;
									}
								}
							}
						}

						.rubric {
							border-bottom: 1px solid #ABCCE9;

							.text {
								border-width: 2px;
								margin-bottom: -1px;
								font-size: 16px;
								padding: 6px 0;
							}
						}
					}
				}
			}
			footer {
				.con {
					width: 100%;
					padding: 10px 0;
					.item {
						padding: 2px 0;
						font-size: 12px;
						line-height: 20px;
					}
				}
			}
		}
	}
</style>